import api from 'services/api';

export const permissionService = {
  // Buscar todas as permissões disponíveis
  async getAll() {
    try {
      const response = await api.get('/permissions');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar permissões:', error);
      throw error;
    }
  },

  // Buscar todas as permissões disponíveis (alias)
  async getAllPermissions() {
    try {
      const response = await api.get('/permissions');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar permissões:', error);
      throw error;
    }
  },

  // Buscar permissões de um usuário específico
  async getUserPermissions(userId) {
    try {
      const response = await api.get(`/users/${userId}/permissions`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar permissões do usuário:', error);
      throw error;
    }
  },

  // Atribuir permissões a um usuário
  async assignPermissions(userId, permissions) {
    try {
      const response = await api.post(`/users/${userId}/permissions`, {
        permissions: permissions
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao atribuir permissões:', error);
      throw error;
    }
  },

  // Remover permissões de um usuário
  async revokePermissions(userId, permissions) {
    try {
      const response = await api.delete(`/users/${userId}/permissions`, {
        data: { permissions: permissions }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao remover permissões:', error);
      throw error;
    }
  },

  // Verificar se usuário tem uma permissão específica
  async checkPermission(userId, permission) {
    try {
      const response = await api.get(`/users/${userId}/permissions/${permission}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao verificar permissão:', error);
      throw error;
    }
  },


  // Buscar empresas que o usuário pode gerenciar
  async getManageableCompanies() {
    try {
      const response = await api.get('/company-access/manageable-companies');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar empresas gerenciáveis:', error);
      throw error;
    }
  },

  // Associar usuário às empresas selecionadas
  async assignUserToCompanies(userId, companyIds) {
    try {
      const response = await api.post(`/company-access/${userId}/assign-companies`, {
        company_ids: companyIds
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao associar usuário às empresas:', error);
      throw error;
    }
  },

      // Atualizar nível de acesso do usuário
      async updateUserAccessLevel(userId, accessLevel) {
        try {
          const response = await api.put(`/company-access/${userId}/access-level`, {
            access_level: accessLevel
          });
          return response.data;
        } catch (error) {
          console.error('Erro ao atualizar nível de acesso:', error);
          throw error;
        }
      },

      // Buscar grupos disponíveis
      async getAvailableGroups() {
        try {
          const response = await api.get('/company-access/available-groups');
          return response.data;
        } catch (error) {
          console.error('Erro ao buscar grupos:', error);
          throw error;
        }
      },

      // Atribuir usuário a um grupo
      async assignUserToGroup(userId, groupId) {
        try {
          const response = await api.put(`/company-access/${userId}/assign-group`, {
            group_id: groupId
          });
          return response.data;
        } catch (error) {
          console.error('Erro ao atribuir usuário ao grupo:', error);
          throw error;
        }
      }
    };

export default permissionService;


